export const MISSION_CATEGORY = {
  KENSHIN: 'KENSHIN',
  SEIMITSU: 'SEIMITSU',
};
